"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZODIAC_TRAITS = void 0;
exports.zodiacTrait = zodiacTrait;
exports.ZODIAC_TRAITS = {
    aries: {
        keywords: 'инициативность, смелость, прямота, импульс, самостоятельность',
        energy: 'Быстрое включение в ситуацию, самостоятельность и готовность действовать. Способность начинать первым, отстаивать позицию и двигаться к цели без долгих сомнений.',
        attention: 'Перед важным решением возьми паузу хотя бы на несколько часов и проверь, действуешь ли ты из реального желания, а не на эмоциях.',
    },
    taurus: {
        keywords: 'устойчивость, практичность, терпение, надёжность, ценности',
        energy: 'Потребность в стабильности, понятных условиях и конкретном результате. Последовательно строить отношения, проекты и финансовую опору, не рассчитывая на быстрый эффект.',
        attention: 'Если ситуация больше не устраивает, назови конкретно, что нужно изменить, вместо того чтобы терпеть и ждать, пока всё решится само.',
    },
    gemini: {
        keywords: 'общение, любопытство, гибкость, интеллект, движение',
        energy: 'Интерес к информации, общению и разным вариантам решения. Быстро ориентироваться, задавать вопросы и менять подход, если прежний не работает.',
        attention: 'Выбери одну главную задачу и доведи её до конкретного результата, не переключаясь каждый раз на новый вариант.',
    },
    cancer: {
        keywords: 'чувствительность, забота, близость, память, безопасность',
        energy: 'Внимание к эмоциональной безопасности, дому, отношениям с близкими и личным границам. Насколько комфортно в ситуации и можно ли открыто говорить о своих потребностях.',
        attention: 'Прямо скажи близким, что тебе нужно, вместо того чтобы ждать, что они сами догадаются о твоём состоянии.',
    },
    leo: {
        keywords: 'уверенность, творчество, достоинство, щедрость, самовыражение',
        energy: 'Желание проявляться, создавать и получать признание. Брать на себя заметную роль, вдохновлять других и действовать с уверенностью.',
        attention: 'Принимай решения, опираясь на свои цели и ценности, а не только на желание получить одобрение или внимание окружающих.',
    },
    virgo: {
        keywords: 'анализ, порядок, практичность, внимание к деталям, ответственность',
        energy: 'Разложить ситуацию на конкретные задачи, увидеть детали и исправить то, что действительно можно улучшить. Результат через последовательность и планирование.',
        attention: 'Определи минимально достаточный результат и остановись на нём, если дальнейшее улучшение требует слишком много сил и времени.',
    },
    libra: {
        keywords: 'баланс, партнёрство, дипломатия, выбор, справедливость',
        energy: 'Потребность в равноправии, уважительном диалоге и согласовании интересов. Насколько отношения или договорённости действительно взаимны.',
        attention: 'Перед тем как согласиться, проверь, действительно ли ты этого хочешь, и спокойно обозначь свой отказ, если решение тебе не подходит.',
    },
    scorpio: {
        keywords: 'глубина, честность, сила, контроль, трансформация',
        energy: 'Глубокий анализ, сильная мотивация и готовность разбираться с неудобными вопросами. Увидеть реальные причины происходящего и понять, что больше не устраивает.',
        attention: 'Если есть сомнения в человеке или ситуации, задай прямой вопрос и оцени ответ по фактам, а не пытайся самостоятельно восстановить скрытые мотивы.',
    },
    sagittarius: {
        keywords: 'свобода, развитие, смысл, расширение возможностей, оптимизм',
        energy: 'Стремление к росту, новым знаниям и более широким возможностям. Не ограничиваться привычным сценарием, но учитывать реальные ресурсы и последствия.',
        attention: 'Прежде чем начинать новый проект, составь конкретный план, сроки и список обязательных шагов.',
    },
    capricorn: {
        keywords: 'цель, дисциплина, ответственность, выдержка, структура',
        energy: 'Долгосрочные цели, профессиональный рост и создание устойчивой основы. Выдерживать нагрузку и добиваться результата через системную работу.',
        attention: 'Запланируй регулярный отдых и пересмотри нагрузку, если выполнение целей требует постоянно работать через усталость.',
    },
    aquarius: {
        keywords: 'независимость, оригинальность, идеи, свобода, изменения',
        energy: 'Нестандартное решение, выход за пределы привычного и действие в соответствии с убеждениями. Ценность самостоятельного мышления и личного пространства.',
        attention: 'Объясни близким свои планы и границы заранее, чтобы самостоятельность не выглядела как отстранённость или безразличие.',
    },
    pisces: {
        keywords: 'эмпатия, воображение, чувствительность, творчество, адаптивность',
        energy: 'Высокая восприимчивость к атмосфере, эмоциям других и собственным состояниям. Важность эмоциональных границ, отдыха и проверки впечатлений фактами.',
        attention: 'Перед важным решением запиши отдельно факты, предположения и эмоции, а затем проверь выводы по реальной информации.',
    },
};
function zodiacTrait(zodiacId) {
    return exports.ZODIAC_TRAITS[zodiacId];
}
//# sourceMappingURL=zodiac-traits.js.map